import { ignoreMissingTranslations, sessionStore, siteSettingsActions } from '../../services';

// abb would like to have integrated version whenever we run in an iframe
const isIntegrated = () => window.parent !== window;

const defaultSettings = {
  applicationName: 'ABB Phase 3',
  isIntegrated: isIntegrated(),
  properties: {
    
  }
};

export const siteSettingsReducer = ( state = defaultSettings, action ) => {
  switch ( action.type ) {
    case siteSettingsActions.LOAD:
      
      if( !action.data.properties.isTestEnvironment ) {
        ignoreMissingTranslations();
      }
      
      sessionStore.set( 'siteSettings', action.data );
      return { ...state, ...action.data, isIntegrated: isIntegrated(), properties: { ...action.data.properties } };
    default:
      return state;
  }
};